import { ApolloClient, NormalizedCacheObject } from '@apollo/client';

import { queryCustomerAccessToken } from '@/shared/graphql/gateway/queries';

export const getCustomerAccessToken = async (
  gatewayApolloClient: ApolloClient<NormalizedCacheObject>
) => {
  const storeName = window.Shopify.shop.split('.')[0]; // TODO: any smarter way of getting the storeName?

  const customerAccessTokenResponse = await gatewayApolloClient.query(
    queryCustomerAccessToken(storeName)
  );

  const customerAccessToken =
    customerAccessTokenResponse.data.shopify?.exchangeToken?.customerAccessToken
      ?.accessToken ?? null;

  if (!customerAccessToken) {
    // Features rely on this
    throw new Error(
      `No customerAccessToken received from Gateway for storeName ${storeName}.`
    );
  }

  return customerAccessToken;
};
